<template>Ukážka pridania tretieho modulu</template>
